<template>
  <div class="props-group">
    <!-- 表格内文件选择控件历史数据listType属性为空,普通的文件选择和上传控件则具有该属性,新表格文件选择则命名为tableFile便于区分-->
    <template v-if="component.properties.listType && component.properties.listType !== 'tableFile'">
      <el-form-item label="是否多选">
        <el-switch v-model="component.properties.multiple"></el-switch>
      </el-form-item>
    </template>
    <template v-if="!component.properties.listType || component.properties.listType === 'text' || component.properties.listType === 'tableFile'">
      <el-form-item label="文件格式">
        <el-select v-model="component.properties.allowFileType" multiple collapse-tags clearable>
          <el-option v-for="type in fileTypeList" :value="type" :label="type" :key="type"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :rules="[{ validator: validateSize, trigger: 'blur' }]" prop="properties.fileSize">
        <template slot="label">
          <span>大小</span>&nbsp;
          <el-tooltip content="单个文件大小不能超过50M。" placement="bottom-start" class="tooltip">
            <span class="fa fa-exclamation-circle"></span>
          </el-tooltip>
        </template>
        <el-input v-model="component.properties.fileSize" @change="changeValue">
          <template slot="append">M</template>
        </el-input>
      </el-form-item>
    </template>
  </div>
</template>

<script>
export default {
  name: 'attr-upload',
  props: ['component'],
  data () {
    return {
      fileTypeList: ['png', 'jpg', 'bmp', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx']
    }
  },
  methods: {
    validateSize (rule, value, callback) {
      if (value && Number(value) > 50) {
        callback(new Error('最大限制为50M'))
      } else {
        callback()
      }
    },
    // 只获取输入的数字
    changeValue (value) {
      let number = this.toNumber(value)
      if (isNaN(number)) {
        number = 0
      }
      this.component.properties.fileSize = number
    },
    // 提取全部的数字和第一位小数点
    toNumber (value) {
      if (value === '' || value === undefined || typeof value === 'number' || value === null) {
        return value
      }
      let dot = value.replace(/[^.]/g, '').length
      let result = value.replace(/[^\-\d.]/g, '')
      // 若存在两个小数点再处理
      if (dot > 1) {
        result = result.replace(/(\.[^.]*)./, '$1')
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/upload.vue